import Vue from 'vue';
import Vuex from 'vuex';
import modelstate from './modelstate.js'
import userInfo from './userInfo.js'
Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
 		 modelstate,
 		 userInfo
  	}
});
export default store
console.log("最外层："+JSON.stringify(store.state.userInfo));


// WEBPACK FOOTER //
// ./src/store/index.js